export default "<main class=\"app-bg--ash-grey\" appFocusAccessibility>\n  <router-outlet></router-outlet>\n</main>\n"